export const endpoints = {
  REGION_TROUBLE_VIEW: "/region/trouble/view",
  REGION_TROUBLE_ATTACH: "/region/trouble/attach",
}